import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "password", "form", "userName"]

  open(event) {
    event.preventDefault()
    const { url, userName } = event.currentTarget.dataset

    this.userNameTarget.textContent = userName
    this.passwordTarget.value = ""
    this.formTarget.action = url

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"

    requestAnimationFrame(() => this.passwordTarget.focus())
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
